import _styled from "@emotion/styled-base";
import { Box } from "../";

var Card = /*#__PURE__*/_styled(Box, {
  target: "eya6tcb0",
  label: "Card"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0NhcmQvQ2FyZC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHd0IiLCJmaWxlIjoiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvQ2FyZC9DYXJkLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgQm94IH0gZnJvbSAnLi4vJztcblxuY29uc3QgQ2FyZCA9IHN0eWxlZChCb3gpYGA7XG5cbkNhcmQuZGVmYXVsdFByb3BzID0ge1xuICBib3hTaGFkb3c6ICdkZWZhdWx0JyxcbiAgYm9yZGVyUmFkaXVzOiAnZGVmYXVsdCcsXG4gIGJnOiAnd2hpdGUnLFxuICBwOiA0LFxufTtcblxuZXhwb3J0IGRlZmF1bHQgQ2FyZDtcbiJdfQ== */");

Card.defaultProps = {
  boxShadow: 'default',
  borderRadius: 'default',
  bg: 'white',
  p: 4
};
export default Card;